<header class="bg-white">
  <div class="container">
    <nav class="navbar navbar-expand-md navbar-light">
      <a class="navbar-brand logo" href="/"><img src="../../assets/images/logo.png" alt=""></a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
        aria-expanded="false" aria-label="Toggle navigation" #button>
        <fa-icon [icon]="faBars"></fa-icon>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">        
        <ul class="navbar-nav mr-auto destop-menu">  
          <li class="nav-item" *ngFor="let menu of menus">
            <a class="nav-link" routerLinkActive="active" routerLink="{{menu.link}}" *ngIf="menu.title === 'Home'"><fa-icon [icon]="faHome"></fa-icon></a>
            <a class="nav-link" routerLinkActive="active" routerLink="{{menu.link}}" *ngIf="menu.title != 'Home'">{{menu.title}}</a>
            <!-- <a class="nav-link" routerLinkActive="active" routerLink="/{{menu.link}}" (click)="button.click()" *ngIf="menu.title != 'Home'">{{menu.title}}</a> -->
          </li>
          <li class="nav-item user dropdown">
            <a class="nav-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <fa-icon [icon]="faUser"></fa-icon>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="nav-link" *ngIf="loginbtn" routerLink="user/login" routerLinkActive="active">Login</a>
              <!-- <a class="nav-link" *ngIf="loginbtn" routerLink="user/registration" routerLinkActive="active">Registration</a> -->
              <a class="nav-link" *ngIf="logoutbtn" routerLink="user/dashboard/main" routerLinkActive="active">Dashboard</a>
              <button type="button" *ngIf="logoutbtn" class="btn btn-block" (click)="logout()">logout</button>
            </div>
          </li>
        </ul>
        <ul class="navbar-nav mr-auto d-sm-none">  
          <li class="nav-item" *ngFor="let menu of menus">
            <a class="nav-link" routerLinkActive="active" routerLink="{{menu.link}}" (click)="button.click()" *ngIf="menu.title === 'Home'"><fa-icon [icon]="faHome"></fa-icon></a>
            <a class="nav-link" routerLinkActive="active" routerLink="{{menu.link}}" (click)="button.click()" *ngIf="menu.title != 'Home'">{{menu.title}}</a>
            <!-- <a class="nav-link" routerLinkActive="active" routerLink="/{{menu.link}}" (click)="button.click()" *ngIf="menu.title != 'Home'">{{menu.title}}</a> -->
          </li>
          <li class="nav-item" *ngIf="loginbtn">
            <a class="nav-link" routerLink="user/login" (click)="button.click()" routerLinkActive="active">Login</a>
          </li>
          <!-- <li class="nav-item" *ngIf="loginbtn">
            <a class="nav-link" routerLink="user/registration" (click)="button.click()" routerLinkActive="active">Registration</a>
          </li> -->
          <li class="nav-item" *ngIf="logoutbtn">
            <a class="nav-link" routerLink="user/dashboard/main" (click)="button.click()" routerLinkActive="active">Dashboard</a>
          </li>
          <li class="nav-item" *ngIf="logoutbtn">
            <button type="button" class="btn btn-block" (click)="logout()">logout</button>
          </li>
        </ul>        
      </div>
    </nav>
    <div id="searchBar">
      <div class="search-icon" data-toggle="collapse" href="#collapseSearch" aria-expanded="false" aria-controls="collapseSearch">
      </div>
    </div>    
    <search-bar></search-bar>
  </div>
</header>
